import CustomChip from '../../../components/CustomChip';
import { useLanguage } from '../../../contexts/language';
import { BADGE_CLASSNAMES } from '../../../utils/styles';

export interface OperatorBadgeProps {
  isActive: boolean;
  small?: boolean;
}

const OperatorBadge = ({ isActive, small }: OperatorBadgeProps) => {
  const { t } = useLanguage();
  return (
    <CustomChip
      label={t(`content.${isActive ? 'active' : 'inactive'}`)}
      small={small}
      className={isActive ? BADGE_CLASSNAMES.GREEN : BADGE_CLASSNAMES.RED}
    />
  );
};

export default OperatorBadge;
